import { useEffect, useRef } from "react";

/** A KYC step-up is offered once per quote, so a repeat failure ends instead of looping. */
export function useKycStepUp(quoteSignature: string) {
  const kycStepUp = useRef(false);

  useEffect(() => {
    kycStepUp.current = false;
  }, [quoteSignature]);

  return kycStepUp;
}
